import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { FaBars } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

export default function TemporaryDrawer() {
  const [open, setOpen] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState('/'); // Default active tab is Home
  const location = useLocation();

  React.useEffect(() => {
    setActiveTab(location.pathname);
  }, [location]);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleTabClick = (path) => {
    setActiveTab(path);
    setOpen(false); // Close the drawer when a tab is clicked
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} onClick={toggleDrawer(false)}>
      <List>
        {[
          { route: 'Home', path: '/' },
          { route: 'Projects', path: '/projects' },
          { route: 'Skills', path: '/skills' },
          { route: 'About', path: '/about' },
        ].map((text, index) => (
          <Link to={text.path} key={text.route} style={{ margin: '10px' }} className='link'>
            <ListItem
              key={text.route}
              onClick={() => handleTabClick(text.path)}
              selected={text.path === activeTab}
            >
              <ListItemText primary={text.route} />
            </ListItem>
          </Link>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <FaBars onClick={toggleDrawer(true)} className='drawer' />
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
